import { createReducer } from "typesafe-actions";

import Route from "@mapmycustomers/shared/types/entity/Route";

import {
  fetchDestinationRoutes,
  hideMoveStops,
  MoveStopsActions,
  showMoveStops,
  transferStops,
} from "./actions";

export interface MoveStopsState {
  routes: Route[];
  routesLoading: boolean;
  sourceRoute?: Route;
  transferring: boolean;
}

const initialState: MoveStopsState = {
  routes: [],
  routesLoading: false,
  sourceRoute: undefined,
  transferring: false,
};

const moveStops = createReducer<MoveStopsState, MoveStopsActions>(initialState)
  .handleAction(showMoveStops, (state, { payload }) => ({
    ...initialState,
    sourceRoute: payload.sourceRoute,
  }))
  .handleAction(hideMoveStops, () => initialState)
  .handleAction(fetchDestinationRoutes.request, (state) => ({ ...state, routesLoading: true }))
  .handleAction(fetchDestinationRoutes.success, (state, { payload }) => ({
    ...state,
    routes: payload,
    routesLoading: false,
  }))
  .handleAction(fetchDestinationRoutes.failure, (state) => ({ ...state, routesLoading: false }))
  .handleAction(transferStops.request, (state) => ({ ...state, transferring: true }))
  .handleAction(transferStops.success, () => initialState)
  .handleAction(transferStops.failure, (state) => ({ ...state, transferring: false }));

export default moveStops;
